export const IP_LOCATION_SET_ERROR = 'IP_LOCATION_SET_ERROR' as const;
export const IP_LOCATION_SET_DATA = 'IP_LOCATION_SET_DATA' as const;
